// Story 6.9 (ADO-1163, AC3) — Check Box. Figma 50:101.
// a11y: native <input type="checkbox"> wrapped in a <label>, so the label text
// is the accessible name and the whole control is clickable/keyboard-operable.

import type { InputHTMLAttributes, ReactNode } from 'react';
import styles from './Checkbox.module.css';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: ReactNode;
}

export function Checkbox({ label, className, ...rest }: CheckboxProps) {
  return (
    <label className={styles.root}>
      <input type="checkbox" className={`${styles.input} ${className ?? ''}`} {...rest} />
      <span className={styles.label}>{label}</span>
    </label>
  );
}
